import { K1World } from '@e3dc-react/icons'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'

interface Props {
  isVisible?: boolean
}

const OfflineStatusIcon: React.FC<Props> = ({ isVisible = false }) => {
  const tooltipText = 'installation-status.offline.tooltip'

  if (isVisible) {
    return (
      <OptionalTooltipWrapper titleKey={tooltipText}>
        <K1World color="error" />
      </OptionalTooltipWrapper>
    )
  }

  return null
}

export default OfflineStatusIcon
